// import React from "react";
// import { Input, Button, Form, Typography } from "antd";
// import { SendOutlined } from "@ant-design/icons";
// import SidebarLayoutConsumer from './SidebarLayoutConsumer';
// const { Title } = Typography;
// const DataInsightsForAdministrator = () => {
//     return (
//         <SidebarLayoutConsumer>
//              <Title level={3}>Data Insights</Title>
//             <div
//                 style={{
//                     height: "90%",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     background: "#f5f6fa",
//                 }}
//             >
//                 <div
//                     style={{
//                         display: "flex",
//                         alignItems: "center",
//                         width: "500px",
//                         maxWidth: "90%",
//                         border: "1px solid #e0e0e0",
//                         borderRadius: "20px",
//                         padding: "5px 10px",
//                         background: "#fff",
//                         boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
//                     }}
//                 >
//                     <Input
//                         placeholder="Here to Help..."
//                         bordered={false}
//                         style={{ flex: 1, fontSize: "16px" }}
//                     />

//                     <Form.Item style={{ margin: 5 }}>
//                         <Button type="primary">
//                             <SendOutlined />
//                         </Button>
//                     </Form.Item>
//                 </div>
//             </div>
//         </SidebarLayoutConsumer>
//     );
// };

// export default DataInsightsForAdministrator;

import React, { useEffect, useState } from "react";
import { Typography, Spin } from "antd";
import SidebarLayoutConsumer from './SidebarLayoutConsumer';
import EchoChat from "../Consumer/EchoChat";
import EchoChatForAdmin from "./EchoChatForAdmin";

const { Title } = Typography;

const AdministratorInsights = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Spin spinning={loading}>
      <SidebarLayoutConsumer>
        <div>
          {/* <Title level={3} style={{ margin: "0 0 20px 0" }}>
            Insights
          </Title> */}

          {/* Reused component */}
          <EchoChatForAdmin />
        </div>
      </SidebarLayoutConsumer>
    </Spin>
  );
};

export default AdministratorInsights;
